import React, {useEffect} from 'react'
import {connect} from 'react-redux'
import {useLocation, useRouteMatch} from 'react-router-dom'
import PropTypes from 'prop-types'
import axios from 'axios'
import useScript from '../../../../core/utils/useScript'

const Recaptcha = props => {
  const {endPage, popularBreeds, rateLimit, siteKey, startPage, threshold, user} = props
  const [recaptchaLoaded] = useScript({
    src: `https://www.google.com/recaptcha/api.js?render=${siteKey}`,
    text: threshold
  })
  let gToken = null
  const location = useLocation()
  const searchFromValues = location.state ? location.state.searchFormValues : null
  const pathname = location.pathname
  const page = searchFromValues ? searchFromValues.page : 1
  const popularBreedsList = popularBreeds.split(',')
  let onPopularBreedSERP = false
  let currentBreed = null
  const onSERP =
    useRouteMatch('/puppies*') ||
    useRouteMatch('/groomers*') ||
    useRouteMatch('/trainers*')

  const checkOnPopularBreedSERP = () => {
    if (onSERP) {
      for (let breed of popularBreedsList) {
        if (Math.floor(Math.random() * rateLimit) === 0 && pathname.includes(breed)) {
          currentBreed = breed
          onPopularBreedSERP = true
          break
        }
      }
    }
  }

  const initRecaptcha = (action, callback = null) => {
    window.grecaptcha.ready(function () {
      window.grecaptcha
        .execute(siteKey, {action: action})
        .then(function (token) {
          gToken = token
          if (callback) {
            callback(gToken)
          }
        })
        .catch(error => console.error('Execute Error: ', error))
    })
  }

  const verify = token => {
    axios.post('/recaptcha',
      {token: token},
      {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      })
      .then(response => response.data)
      .then(data => {
        if (data.success && data.response.score <= threshold) {
          if (pathname !== '/') window.location.href = window.location.origin
          const botDetails = {
            breed: currentBreed,
            page,
            score: data.response.score
          }

          if (user) {
            botDetails.id = user.id
            botDetails.email = user.email
            botDetails.name = user.name
            botDetails.last_login = user.last_login
          }

          axios.post('/log-bot-details', botDetails)
        }
      })
      .catch(error => console.error('Error verifying token:', error))
  }

  useEffect(() => {
    if (recaptchaLoaded && siteKey) {
      checkOnPopularBreedSERP()
      if (onPopularBreedSERP &&
        ((page >= startPage && page < endPage) || (page >= startPage && parseInt(endPage) === 0))
      ) {
        initRecaptcha('top_breeds_first_two_pages', verify)
      }
    }
  }, [recaptchaLoaded, onPopularBreedSERP, onSERP, page])

  return (
    recaptchaLoaded && siteKey &&
    <div
      className='g-recaptcha'
      data-sitekey={siteKey}
      data-size='invisible'
    ></div>
  )
}

Recaptcha.propTypes = {
  endPage: PropTypes.string,
  popularBreeds: PropTypes.string,
  rateLimit: PropTypes.string,
  siteKey: PropTypes.string,
  startPage: PropTypes.string,
  threshold: PropTypes.string,
  user: PropTypes.object
}

const mapStateToProps = state => ({
  endPage: state.app.google_recaptcha.end_page,
  popularBreeds: state.app.google_recaptcha.popular_breeds,
  rateLimit: state.app.google_recaptcha.rate_limit,
  siteKey: state.app.google_recaptcha.site_key,
  startPage: state.app.google_recaptcha.start_page,
  threshold: state.app.google_recaptcha.threshold,
  user: state.app.user
})

export default connect(
  mapStateToProps,
  null
)(Recaptcha)
